import { Component, OnInit } from '@angular/core';
import { releaseNotes } from '../../constants/release-notes.const';

@Component({
  selector: 'app-release-notes-dialog',
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss'],
  standalone: false,
})
export class ReleaseNotesDialogComponent implements OnInit {
  releaseNotes = releaseNotes;

  constructor() {}

  ngOnInit() {}
}
